var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('el-carousel',{attrs:{"height":"52vw","arrow":"always"}},_vm._l((_vm.imgList),function(item,index){return _c('el-carousel-item',{key:index},[_c('a',{attrs:{"href":item.url}},[_c('img',{attrs:{"src":item.img,"alt":""}})])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }